import { render, staticRenderFns } from "./EncerrarConta.vue?vue&type=template&id=6e5af040"
import script from "./EncerrarConta.vue?vue&type=script&lang=ts"
export * from "./EncerrarConta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports